export const IS_GIFT_CARD_GLOBAL = true;
export const IS_AI_ANALYSIS_ENABLED = false;

export const IS_AI_ENABLED_FOR_WARSZAWA = false;
export const IS_AI_ENABLED_FOR_POZNAN = false;
export const IS_AI_ENABLED_FOR_KRAKOW = true;
export const IS_AI_ENABLED_FOR_WROCLAW = false;
export const IS_AI_ENABLED_FOR_GDANSK = true;
export const IS_AI_ENABLED_FOR_SZCZECIN = true;
export const IS_AI_ENABLED_FOR_KATOWICE = false;